import { EJRecordTypes } from 'src/common/enumerations/ej-record-types';
import { UnitOfMeasureTypes } from 'src/common/enumerations/unit-of-measure-type';
import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';

export const itemCount = (ejItems: IElectronicJournalRecord[], itemType: EJRecordTypes): number =>
  ejItems
    .filter((item: IElectronicJournalRecord) => item.Type === itemType && !item.Voided)
    .map(x => (x.UnitOfMeasureCode !== UnitOfMeasureTypes.Each ? 1 : x.Quantity || 0))
    .reduce((total, current) => total + current, 0);

export const tbrItemCount = (ejItems: IElectronicJournalRecord[]): number =>
  ejItems
    .filter((item: IElectronicJournalRecord) => item.tbrReturnItem)
    .map(x => (x.UnitOfMeasureCode !== UnitOfMeasureTypes.Each ? 1 : x.tbrAvailableQty || 0))
    .reduce((total, current) => total + current, 0);
